"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VEHICLES_LIST = exports.PROXY_API = exports.BASE_URL = exports.proxyDomain = void 0;
exports.proxyDomain = process.env.REACT_APP_PROXY_API_URL;
exports.BASE_URL = "".concat(exports.proxyDomain, "/api");
exports.PROXY_API = {
    GET: {
        VEHICLE: {
            LIST_PAGE_TAN: '/vehicle/:tan/status',
            LIST: '/vehicle/:tan/getVehiclesByTan',
            INFO: '/vehicle/:tan/:vin/info',
            VEHICLE_BRIEFINFO: '/vehicle/:tan/briefInfo',
        },
        VEHICLE_INFO: '/vehicle/:tan/:vin/info',
        FAULT: {
            FAULT_SEARCH: '/fault/v1/global/fault?faultSearchCriteria&tan=:tan',
            /** @deprecated use EVENT_BY_STREAMING_SOURCE_AND_EVENT_ID */
            EVENT_BY_EVENTID: '/fault/event/:eventId',
            /** @deprecated use EVENT_BY_STREAMING_SOURCE_AND_ID */
            EVENT_BY_ROWKEY: '/fault/:rowKey',
            VT_EVENT_BY_ID: '/fault/v1/global/fault/vt/event/:eventId',
            EVENT_BY_STREAMING_SOURCE_AND_EVENT_ID: '/fault/v1/global/fault/event/:streamingSource/:eventId',
            EVENT_BY_STREAMING_SOURCE_AND_ID: '/fault/v1/global/fault/:streamingSource/:rowKeyOrFaultId',
            TAN_EVENT_BY_RINGBUFFER_ROWKEY: '/fault/ringbuffer/:tan/:rowKey',
        },
        VEHICLES_LIST_PAGE_TAN: '/vehicle/:tan/status',
    },
    PATCH: {
        FAULT: {
            TAN_UPDATE_FLAG_RESOLVE: '/fault/:tan/updateFlagResolve',
        },
    },
    POST: {
        VEHICLE: {
            TAGS_TAN: '/vehicle/:tan/customTags',
        },
    },
    PUT: {},
    DELETE: {},
};
exports.VEHICLES_LIST = {
    RECORDS_PER_REQUEST: 30000,
    DOWNLOAD_CSV_RECORDS_PER_REQUEST: 80000,
    RETRY_LIMIT: 6,
};
